// extracted by mini-css-extract-plugin
export default {"image":"ImageGalleryItem_image__NRKYb","imageItem":"ImageGalleryItem_imageItem__v+HHa"};